module.exports = __webpack_public_path__ + "img/studiosha_block.132f97ea.png";